import {
  AD_ACCESS_TOKEN_START,
  AD_ACCESS_TOKEN_FAILED,
  AD_ACCESS_TOKEN_SUCCESS,
  AD_LOGIN_SUCCESS,
  AD_LOGIN_FAILED,
  AdfsAuth,
  INITIALIZE_AD_AUTH_SUCCESS,
  INITIALIZE_AD_AUTH_FAILED,
  AD_LOGIN_REDIRECT_FAILED,
  AD_LOGIN_REDIRECT_SUCCESS,
  CIAM_LOGIN_STARTED,
  CIAM_LOGIN_SUCCESS
} from './types';

const normalizeError = error => {
  let normalizedError = {};
  if (typeof error === 'string') {
    const errParts = error.split('|');
    normalizedError = errParts.length > 1 ? { message: errParts[1], debug: errParts[0] } : { message: error };
  } else {
    normalizedError = {
      message: error.message,
      debug: JSON.stringify(error)
    };
  }
  return normalizedError;
};

export const adfsAuth = (
  state: AdfsAuth = {},
  action: {
    type: string;
    payload?: unknown;
  }
): AdfsAuth => {
  switch (action.type) {
    case INITIALIZE_AD_AUTH_SUCCESS:
      return { ...state, msalError: null };
    case INITIALIZE_AD_AUTH_FAILED:
      return { ...state, msalError: normalizeError(action.payload) };
    case AD_LOGIN_SUCCESS:
      return { ...state, login: action.payload };
    case AD_LOGIN_FAILED:
      return { ...state, loginError: normalizeError(action.payload) };
    case AD_ACCESS_TOKEN_START:
      return { ...state, tokenPending: true, tokenSet: {} };
    case AD_LOGIN_REDIRECT_SUCCESS:
      return { ...state, adLoginRedirectError: null };
    case AD_LOGIN_REDIRECT_FAILED:
      return { ...state, adLoginRedirectError: normalizeError(action.payload) };
    case AD_ACCESS_TOKEN_SUCCESS:
      return { ...state, tokenPending: false, tokenSet: action.payload };
    case AD_ACCESS_TOKEN_FAILED:
      return { ...state, tokenPending: false, tokenError: normalizeError(action.payload) };
    case CIAM_LOGIN_STARTED:
      return { ...state, loginPending: true, tokenPending: true };
    case CIAM_LOGIN_SUCCESS:      
      return { ...state, loginPending: false, tokenPending: false};
    default:
      return state;
  }
};
